import { FC, useCallback } from 'react';
import * as React from 'react';

import { useTranslation } from '@crehana/i18n';

import { TKeys } from '../../../../../i18n/types';
import InputField, { InputState } from '../InputField';
import { Validation } from '../InputField/types';
import { NameMask } from '../InputField/utils/NameMask';
import { NameState } from './types';

type Props = {
  onChange: (value: NameState) => void;
  isLastName?: boolean;
  required?: boolean;
  value?: string;
  placeholder?: string;
};

const mask = new NameMask();

const NameInput: FC<React.PropsWithChildren<Props>> = ({
  onChange,
  required,
  value,
  isLastName = false,
  placeholder,
}) => {
  const { t } = useTranslation<TKeys>();

  const handleOnChange = ({ maskedValue, isValid }: InputState) => {
    onChange({
      name: maskedValue,
      isValid,
    });
  };

  const label = isLastName ? 'LAST_NAME' : 'NAME';

  const validation: Validation = useCallback(
    ({ maskedValue }) => {
      if (maskedValue.length === 0)
        return { isValid: false, errorMessage: t(`REQUIRED_${label}`) };
      if (maskedValue.length < 3)
        return { isValid: false, errorMessage: t(`INVALID_${label}`) };
      return { isValid: true, errorMessage: '' };
    },
    [t, label],
  );

  return (
    <div className="mb-24">
      <InputField
        onChange={handleOnChange}
        label={t(`${label}_LABEL`)}
        validation={validation}
        required={required}
        value={value}
        mask={mask}
        placeholder={placeholder}
        darkMode
      />
    </div>
  );
};

export default NameInput;
